import PropTypes from "prop-types"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function TotalCostOfOwnershipSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("customer-apps-total-cost-of-ownership")
  return (
    <Container className={className} section>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-10 lg:mt-0 max-w-md mx-auto lg:w-[30%] lg:mr-[7%]"
      >
        <Heading
          label="Total Cost of Ownership"
          title="Reduce development costs"
          subtitle={
            <>
              Reduce engineering efforts for building data apps using Preset’s
              plug-and-play solution. Preset’s hosted solution takes care of the
              backend - from enterprise governance and security to performance
              and reliability - at a scalable cost.
            </>
          }
          narrow
        />
      </SplitContainer>
    </Container>
  )
}

TotalCostOfOwnershipSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default TotalCostOfOwnershipSection
